import { render } from "./InventoryCategoriesExportsReports.vue?vue&type=template&id=4eb77e9a&ts=true"
import script from "./InventoryCategoriesExportsReports.vue?vue&type=script&lang=ts"
export * from "./InventoryCategoriesExportsReports.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__